import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { offerInfoSortingFunc } from '../utils/offerUtils';
export const reducePromotionsResponse = data => {
  if (data && data.productsEligibleForDirectPromotions) {
    const offersMap = Object.keys(data.offersById).reduce((acc, offerId) => {
      const {
        commitmentTerm,
        paymentTerm,
        discount
      } = data.offersById[offerId];
      return Object.assign({}, acc, {
        [offerId]: {
          commitment: commitmentTerm.toLowerCase(),
          payment: paymentTerm.toLowerCase(),
          discount
        }
      });
    }, {});

    const getSortedOfferIds = (offerIds = []) => offerIds.sort((firstOfferId, secondOfferId) => {
      return offerInfoSortingFunc(offersMap[firstOfferId] || null, offersMap[secondOfferId] || null);
    });

    const crmSuiteOfferIds = Object.keys(data.crmSuiteOfferIds).reduce((suiteOffersObj, keyName) => {
      const keyMap = {
        starterOfferIds: STARTER,
        professionalOfferIds: PROFESSIONAL,
        enterpriseOfferIds: ENTERPRISE
      };
      const {
        productOfferIds,
        quantityPackOfferIds,
        seatsOfferIds
      } = data.crmSuiteOfferIds[keyName];
      const sortedProductOfferIds = getSortedOfferIds(productOfferIds);
      const sortedSeatOfferIds = getSortedOfferIds(seatsOfferIds);
      const sortedQuantityPackOfferIds = Object.keys(quantityPackOfferIds).reduce((sortedObj, apiName) => {
        const sortedOfferIds = Object.keys(quantityPackOfferIds[apiName]).reduce((sortedOffers, unitType) => Object.assign({}, sortedOffers, {
          [unitType]: getSortedOfferIds(quantityPackOfferIds[apiName][unitType])
        }), {});
        return Object.assign({}, sortedObj, {
          [apiName]: sortedOfferIds
        });
      }, {});
      return Object.assign({}, suiteOffersObj, {
        [keyMap[keyName]]: {
          productOfferIds: sortedProductOfferIds,
          quantityPackOfferIds: sortedQuantityPackOfferIds,
          seatsOfferIds: sortedSeatOfferIds
        }
      });
    }, {});
    return Object.assign({}, data, {
      offersById: offersMap,
      crmSuiteOfferIds
    });
  }

  return data;
};